<template>
	<div>
		<div class="page">
			<div v-if="showIntro" class="grid grid-nogutter surface-0 p-6 pt-0 text-800 overflow-auto">
				<div class="w-full flex border-bottom-1 surface-border">
					<div class="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
						<section>
							<span class="block text-6xl font-bold mb-1" style="color: #000; line-height: normal">Welcome to NightPay</span>
							<div class="text-6xl text-primary font-bold mb-3" style="color: #5e81ac">Administration</div>
							<p class="mt-0 mb-5 text-700 line-height-3" style="color: #2e3440 !important; line-height: 1.5rem !important; font-weight: 500">
								This portal provides you with all the features needed to operate NightPay.
							</p>

							<Button label="See intro" @click="selectCaseTypeDialogVisible = true" class="mr-3 modern-button modern-button-primary" icon="fas fa-play"></Button>
							<Button label="Read more" class="modern-button modern-button-outline" icon="fas fa-book-open"></Button>
						</section>
					</div>
					<div class="col-12 md:col-6 overflow-hidden">
						<img src="@/assets/images/hero.jpg" alt="Image" class="md:ml-auto block md:h-full " style="clip-path: polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" />
					</div>
				</div>

				<!-- Latest Transactions Section -->
				<div class="col-12 mt-6">
					<div class="flex align-items-center justify-content-between mb-4">
						<div class="flex align-items-center">
							<div class="font-bold text-900 text-2xl">Latest Transactions</div>
							<div class="ml-3 flex align-items-center">
								<div class="live-indicator" :class="{ 'pulse': !loadingTransactions }"></div>
								<span class="text-sm text-500 ml-2">Live</span>
							</div>
						</div>
						<div class="flex align-items-center">
							<div v-if="loadingTransactions" class="loading-dots">
								<span></span>
								<span></span>
								<span></span>
							</div>
							<div v-else class="text-sm text-500">{{ latestTransactions.length }} recent transactions</div>
						</div>
					</div>

					<div class="transactions-container">
						<div v-if="loadingTransactions && latestTransactions.length === 0" class="loading-state">
							<div class="loading-pulse"></div>
							<div class="loading-pulse delay-1"></div>
							<div class="loading-pulse delay-2"></div>
						</div>
						
						<div v-else-if="latestTransactions.length === 0" class="empty-state">
							<div class="empty-icon">
								<i class="fas fa-clock"></i>
							</div>
							<h3>Waiting for transactions</h3>
							<p>New payments will appear here in real-time</p>
						</div>
						
						<div v-else class="transactions-list">
							<div v-for="(transaction, index) in latestTransactions" 
								:key="transaction.id" 
								class="transaction-card"
								:style="{ '--delay': index * 0.1 + 's' }">
								
								<div class="transaction-header">
									<div class="venue-info">
										<div class="venue-avatar">
											<i class="fas fa-store"></i>
										</div>
										<div class="venue-details">
											<h4 class="venue-name">{{ transaction.venueName }}</h4>
											<div class="transaction-meta">
												<span class="product-count">
													<i class="fas fa-shopping-bag"></i>
													{{ transaction.numberOfProducts }} {{ transaction.numberOfProducts === 1 ? 'item' : 'items' }}
												</span>
												<span class="transaction-time">
													<i class="fas fa-clock"></i>
													{{ formatTimeAgo(transaction.created) }}
												</span>
											</div>
										</div>
									</div>
									<div class="amount-badge">
										{{ formatAmount(transaction.amountTotal, transaction.currencyCode) }}
									</div>
								</div>
								
								<div class="transaction-footer">
									<div class="status-indicator success">
										<i class="fas fa-check-circle"></i>
										<span>Completed</span>
									</div>
									<div class="transaction-id">#{{ transaction.id.slice(-6) }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--
      <div v-else>
        <div class="row">
          <div class="col">
            <div class="card hero">
              <div class="card-body extra-padding" style="display: flex;flex-direction: row;justify-content: space-between;">
                <div>
                  <h3 v-if="$auth.isAuthenticated" class="welcome-message">Velkommen, {{ $auth.user.value.given_name }}</h3>
                  <h1 class="header-title">Der er nyt i sagen.</h1>
                </div>

                <div style="display: flex;flex-direction: row;align-items: center;">
                  <a href="#" class="btn btn-text text-white"><i class="far fa-comment-dots"></i> Giv feedback</a>
                  <a href="#" class="btn btn-primary"><i class="fas fa-bolt"></i> Hurtig søg</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h2 class="section-header mt-5">Ting du skal tage stilling til</h2>
        <div class="row">
          <div class="col-8">
            <div class="primary-action-cards-container">
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">Cras justo odio</li>
                  <li class="list-group-item">Dapibus ac facilisis in</li>
                  <li class="list-group-item">Vestibulum at eros</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="secondary-action-cards-container">
              <div class="card">
                <div class="card-body">
                  <i class="fas fa-calendar-alt"></i> <span style="margin-left:10px">Kommende aktiviteter</span>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <i class="fas fa-envelope"></i> <span style="margin-left:10px">Indbakke (3)</span>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <i class="fas fa-star"></i> <span style="margin-left:10px">Favoritter</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h2 class="section-header mt-5">Personer tilknyttet sagen (3)</h2>
        <div class="row">
          <div class="col">
            <div class="card">
              <div class="card-body connection">
                <div class="card with-border">
                  <div class="card-body connection-link">
                    <div class="horizontal">
                      <h1><span class="badge badge-info">D</span></h1>
                      <div class="badge-label-container">
                        <h3 class="badge-label">Mikkel Hempel</h3>
                        <p class="badge-label">Bobestyrer</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body connection">
                <div class="card with-border">
                  <div class="card-body connection-link">
                    <div class="horizontal">
                      <h1><span class="badge badge-success">P</span></h1>
                      <div class="badge-label-container">
                        <h3 class="badge-label">Peter Roel Jørgensen</h3>
                        <p class="badge-label">Pårørende</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" style="padding-bottom:25px;">
              <div class="card-body connection">
                <div class="card with-border">
                  <div class="card-body connection-link">
                    <div class="horizontal">
                      <h1><span class="badge badge-dark">H</span></h1>
                      <div class="badge-label-container">
                        <h3 class="badge-label">Henrik Bechmann</h3>
                        <p class="badge-label">Bankrådgiver</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->
		</div>
	</div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useStore } from 'vuex';
/*
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useToast } from "vue-toastification";
*/

export default {
	inject: ['hasPermission'],
	name: 'Dashboard',
	components: {},
	props: {},
	setup(/*props*/) {
		const loading = ref(true);
		const store = useStore();
		let pollingInterval = null;
		let timestampInterval = null;

		/*
    const store = useStore()
    const route = useRoute()
    const toast = useToast()
    */

		// Computed properties from store
		const latestTransactions = computed(() => store.getters['userPayments/latestTransactions']);
		const loadingTransactions = computed(() => store.getters['userPayments/latestTransactionsLoading']);

		async function loadRequiredData() {
			loading.value = true;
			await fetchLatestTransactions();
			loading.value = false;
		}

		async function fetchLatestTransactions() {
			try {
				await store.dispatch('userPayments/getLatestTransactions', { limit: 10 });
			} catch (error) {
				console.error('Failed to fetch latest transactions:', error);
			}
		}

		function startPolling() {
			// Poll every 5 seconds for new data
			pollingInterval = setInterval(fetchLatestTransactions, 5000);
			
			// Update timestamps every 30 seconds for real-time feel
			timestampInterval = setInterval(() => {
				// This will trigger reactivity and update the displayed times
				// by forcing a re-render of the timestamp display
			}, 30000);
		}

		function stopPolling() {
			if (pollingInterval) {
				clearInterval(pollingInterval);
				pollingInterval = null;
			}
			if (timestampInterval) {
				clearInterval(timestampInterval);
				timestampInterval = null;
			}
		}

		function formatAmount(amount, currencyCode) {
			return new Intl.NumberFormat('da-DK', {
				style: 'currency',
				currency: currencyCode || 'DKK'
			}).format(amount);
		}

		function formatTimeAgo(dateString) {
			const date = new Date(dateString);
			const now = new Date();
			const diffInSeconds = Math.floor((now - date) / 1000);

			if (diffInSeconds < 30) {
				return 'Just now';
			} else if (diffInSeconds < 60) {
				return `${diffInSeconds}s ago`;
			} else if (diffInSeconds < 3600) {
				const minutes = Math.floor(diffInSeconds / 60);
				return `${minutes}m ago`;
			} else if (diffInSeconds < 86400) {
				const hours = Math.floor(diffInSeconds / 3600);
				return `${hours}h ago`;
			} else {
				const days = Math.floor(diffInSeconds / 86400);
				return `${days}d ago`;
			}
		}

		onMounted(async () => {
			await loadRequiredData();
			startPolling();
		});

		onUnmounted(() => {
			stopPolling();
		});

		return {
			loading,
			loadingTransactions,
			latestTransactions,
			showIntro: true,
			formatAmount,
			formatTimeAgo,
		};
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-primary {
	color: #5e81ac !important;
}

.card.hero {
	background: rgb(4, 88, 204);
	background: linear-gradient(90deg, rgba(4, 88, 204, 1) 0%, rgba(4, 100, 234, 1) 100%);
	border-radius: 10px;
}
.card.hero h3 {
	color: white;
}
.card.hero h1 {
	color: white;
}

.workspace-link:hover {
	cursor: pointer;
	background-color: ghostwhite;
}

.card {
	border: none;
}

.welcome-message {
	font-size: 18px;
	font-weight: 500;
	margin-bottom: 0.75em;
}

.header-title {
	font-size: 32px;
	font-weight: 500;
	margin-top: 0px;
	margin-bottom: 0px;
}

.card-body.extra-padding {
	padding: 2.25rem;
}

.primary-action-cards-container {
	display: flex;
	height: 280px;

	border: 2px solid #edeff3;
	border-radius: 5px;
}

.primary-action-cards-container .card {
	width: 100%;
}

.secondary-action-cards-container {
	display: flex;
	flex-direction: column;
	height: 280px;
	justify-content: space-between;
}

.secondary-action-cards-container .card {
	background-color: #677383;
	color: white;
}

.secondary-action-cards-container .card .card-body {
	padding: 1.75rem;
}

.card.with-border {
	border: 1px solid #edeff3;
}

.horizontal {
	display: flex;
	justify-content: left;
	align-items: center;
}

.badge-label {
	font-size: 14px;
	font-weight: 500;
	margin-top: 0;
	margin-bottom: 0;
	margin-left: 10px;
}

.badge-label-container {
	margin-top: 0;
	margin-bottom: 0;
	margin-left: 10px;
}

.badge-label {
	margin: 0;
}

h3.badge-label {
	font-size: 18px;
	font-weight: 500;
}

.connection.card-body {
	padding-top: 5px;
	padding-bottom: 5px;
}

.live-indicator {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #4caf50;
	display: inline-block;
	margin-right: 5px;
}

.pulse {
	animation: pulse 1.5s ease-out infinite;
}

@keyframes pulse {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
	}
	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
	}
	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
	}
}

.loading-dots {
	display: inline-block;
	position: relative;
	width: 64px;
	height: 16px;
}

.loading-dots span {
	position: absolute;
	top: 0;
	width: 13px;
	height: 13px;
	border-radius: 50%;
	background: #5e81ac;
	animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.loading-dots span:nth-child(1) {
	left: 6px;
	animation: loading-dots1 0.6s infinite;
}

.loading-dots span:nth-child(2) {
	left: 6px;
	animation: loading-dots2 0.6s infinite;
}

.loading-dots span:nth-child(3) {
	left: 26px;
	animation: loading-dots2 0.6s infinite;
}

.loading-dots span:nth-child(4) {
	left: 45px;
	animation: loading-dots3 0.6s infinite;
}

@keyframes loading-dots1 {
	0% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes loading-dots2 {
	0% {
		transform: translate(0, 0);
	}
	100% {
		transform: translate(19px, 0);
	}
}

@keyframes loading-dots3 {
	0% {
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
}

.transactions-container {
	margin-top: 20px;
	width: 100%;
	display: block;
}

.loading-state {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 200px;
	width: 100%;
}

.empty-state {
	text-align: center;
	padding: 60px 20px;
	color: #64748b;
	width: 100%;
}

.empty-icon {
	font-size: 48px;
	color: #5e81ac;
	margin-bottom: 10px;
}

.transactions-list {
	display: flex;
	flex-direction: column;
	gap: 16px;
	max-width: 100%;
	width: 100%;
}

.transaction-card {
	background: #ffffff;
	border-radius: 16px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	overflow: hidden;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	border: 1px solid rgba(0, 0, 0, 0.05);
	animation: slideInUp 0.6s ease-out;
	animation-delay: var(--delay);
	animation-fill-mode: both;
	width: 100%;
	max-width: 800px;
}

.transaction-card:hover {
	transform: translateY(-4px);
	box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.transaction-header {
	padding: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.venue-info {
	display: flex;
	align-items: center;
	flex: 1;
}

.venue-avatar {
	width: 48px;
	height: 48px;
	border-radius: 12px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 16px;
	font-size: 16px;
}

.venue-details {
	flex: 1;
}

.venue-name {
	font-size: 18px;
	font-weight: 600;
	color: #1a202c;
	margin: 0 0 8px 0;
	line-height: 1.2;
}

.transaction-meta {
	display: flex;
	align-items: center;
	gap: 20px;
}

.product-count, .transaction-time {
	font-size: 14px;
	color: #718096;
	display: flex;
	align-items: center;
	gap: 6px;
}

.amount-badge {
	font-size: 18px;
	font-weight: 700;
	color: #ffffff;
	padding: 10px 20px;
	border-radius: 25px;
	background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
	box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
	white-space: nowrap;
}

.transaction-footer {
	padding: 16px;
	background: #f8fafc;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.status-indicator.success {
	color: #059669;
	font-size: 13px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 6px;
}

.transaction-id {
	font-size: 12px;
	color: #9ca3af;
	font-weight: 500;
	font-family: 'Courier New', monospace;
}

.loading-pulse {
	background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
	border-radius: 12px;
	height: 120px;
	margin-bottom: 20px;
	animation: loading-wave 1.5s infinite ease-in-out;
}

.loading-pulse.delay-1 {
	animation-delay: 0.3s;
}

.loading-pulse.delay-2 {
	animation-delay: 0.6s;
}

@keyframes loading-wave {
	0% {
		background-position: -200px 0;
	}
	100% {
		background-position: calc(200px + 100%) 0;
	}
}

@keyframes slideInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.empty-state {
	text-align: center;
	padding: 60px 20px;
	color: #64748b;
}

.empty-state .empty-icon {
	font-size: 64px;
	color: #cbd5e1;
	margin-bottom: 20px;
}

.empty-state h3 {
	font-size: 20px;
	font-weight: 600;
	color: #334155;
	margin: 0 0 8px 0;
}

.empty-state p {
	font-size: 14px;
	color: #64748b;
	margin: 0;
}

@media (max-width: 768px) {
	.transactions-list {
		gap: 12px;
	}
	
	.transaction-header {
		padding: 16px;
		flex-direction: column;
		align-items: flex-start;
		gap: 16px;
	}
	
	.venue-info {
		width: 100%;
	}
	
	.transaction-meta {
		flex-direction: column;
		align-items: flex-start;
		gap: 8px;
	}
	
	.amount-badge {
		align-self: flex-end;
		font-size: 16px;
		padding: 8px 16px;
	}
	
	.venue-name {
		font-size: 16px;
	}
	
	.venue-avatar {
		width: 40px;
		height: 40px;
		font-size: 14px;
	}
}

/* Modern Button Styles */
.modern-button {
	border-radius: 12px !important;
	padding: 12px 24px !important;
	font-weight: 600 !important;
	font-size: 14px !important;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
	border: none !important;
	position: relative !important;
	overflow: hidden !important;
	text-transform: none !important;
	letter-spacing: 0.025em !important;
}

.modern-button-primary {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
	color: white !important;
	box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
}

.modern-button-primary:hover {
	transform: translateY(-2px) !important;
	box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6) !important;
	background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%) !important;
}

.modern-button-outline {
	background: transparent !important;
	color: #667eea !important;
	border: 2px solid #667eea !important;
	box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1) !important;
}

.modern-button-outline:hover {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
	color: white !important;
	transform: translateY(-2px) !important;
	box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
	border-color: transparent !important;
}

.modern-button:focus {
	box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3) !important;
}

.modern-button:active {
	transform: translateY(0) !important;
}
</style>
